// What? A modal component for creating a new organization.
// Why? To separate modal logic from the main dashboard.
// How? Renders a form modal for organization creation.

import React from "react";
import {
  Modal,
  ModalDialog,
  DialogTitle,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Alert,
} from "@mui/joy";

interface CreateOrganizationModalProps {
  open: boolean;
  onClose: () => void;
  orgName: string;
  onOrgNameChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  creating: boolean;
  error: string | null;
}

const CreateOrganizationModal: React.FC<CreateOrganizationModalProps> = ({
  open,
  onClose,
  orgName,
  onOrgNameChange,
  onSubmit,
  creating,
  error,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        size="md"
        variant="outlined"
        sx={{
          maxWidth: 400,
          width: "100%",
        }}
      >
        <DialogTitle>Create Organization</DialogTitle>

        <form onSubmit={onSubmit}>
          <Stack spacing={3}>
            {error && (
              <Alert color="danger" variant="soft">
                {error}
              </Alert>
            )}

            <FormControl required>
              <FormLabel>Organization Name</FormLabel>
              <Input
                name="orgName"
                autoFocus
                required
                placeholder="Enter organization name"
                value={orgName}
                onChange={(e) => onOrgNameChange(e.target.value)}
                size="md"
                disabled={creating}
              />
            </FormControl>

            {/* Button container with proper spacing */}
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              sx={{ pt: 1 }}
            >
              <Button
                variant="outlined"
                color="neutral"
                onClick={onClose}
                size="md"
                disabled={creating}
              >
                Cancel
              </Button>
              <Button
                variant="solid"
                color="primary"
                type="submit"
                size="md"
                loading={creating}
              >
                Create Organization
              </Button>
            </Stack>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default CreateOrganizationModal;
